"use client";

import styles from "./LoginForgotPasswordLink.module.scss";
import { useLocale, useTranslations } from "@/i18n";
import { withLocale } from "@/helpers";
import { Link } from "react-router-dom";

/**
 * LoginForgotPasswordLink Component
 *
 * Link to password reset page for users who forgot their password.
 */
export const LoginForgotPasswordLink = () => {
  const t = useTranslations("login.form");
  const locale = useLocale();

  return (
    <Link
      to={withLocale(locale, "/forgot-password")}
      className={styles["comp"]}
    >
      {t("forgotPassword")}
    </Link>
  );
};
